import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { EmpresaService } from '../../../shared/services/apis/usuario/empresa.service';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { ListaEmpresaResponse } from '../../../shared/services/responses/usuario/lista-empresa.response';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PermissaoEnum } from '../../../shared/enums/permissao.enum';
import { EmptyListComponent } from '../../../shared/components/empty-list/empty-list.component';
import { LoadingBoxComponent } from '../../../shared/components/loading-box/loading-box.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { Empresa } from '../../../shared/services/models/usuario/empresa.model';
import { TemPermissaoDirective } from '../../../shared/directives/habilita-por-permissao.directive';
import { CnpjPipe } from '../../../shared/pipes/cnpj.pipe';
import { EmpresaStruct } from '../../../shared/services/structs/usuario/empresa.struct';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';

@Component({
  selector: 'app-empresa-lista',
  imports: [
    MenuComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    LoadingBoxComponent,
    RouterModule,
    EmptyListComponent,
    MatTooltipModule,
    MatSelectModule,
    MatSlideToggleModule,
    TemPermissaoDirective,
    CnpjPipe,
    SelectPesquisavelComponent,
  ],
  templateUrl: './empresa-lista.component.html',
  styleUrl: './empresa-lista.component.css',
})
export class EmpresaListaComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private empresaService: EmpresaService,
    private alertService: AlertService,
    private dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Implantacao;
    this.funcionalidadeEnum = FuncionalidadeEnum.Implantacao_Empresa;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _listaEmpresaResponse: ListaEmpresaResponse | undefined;
  public displayedColumns: string[] = ['idEmpresa', 'nomeEmpresa', 'cnpj', 'action-edit'];
  public _dataSource = new MatTableDataSource<EmpresaStruct>();
  public _paginaAtual: number = 0;
  public _ultimaPagina: boolean = false;
  public _PermissaoEnum = PermissaoEnum;
  public urlListEmpresaGrupo: string;

  ngOnInit(): void {
    this.model = this.formBuilder.group({
      cnpj: [''],
      razaoSocial: [''],
      idEmpresaGrupo: [null],
    });

    this.urlListEmpresaGrupo = environment.urlApiUsuario + 'EmpresaGrupo/admin/lookup';

    this.pesquisar();
  }

  private pesquisar(): void {
    if (this.model.invalid || this._isLoading === true) {
      return;
    }

    this._isLoading = true;
    const cnpj: string = this.model.get('cnpj')?.value || '';
    const razaoSocial: string = this.model.get('razaoSocial')?.value || '';
    const idEmpresaGrupo: number | null = this.model.get('idEmpresaGrupo')?.value;

    this.empresaService.get(cnpj, razaoSocial, idEmpresaGrupo, this._paginaAtual).subscribe({
      next: (response: ListaEmpresaResponse) => {
        this._isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }

        this._ultimaPagina = true;

        if (!this._listaEmpresaResponse) {
          this._listaEmpresaResponse = response;
          this._ultimaPagina = false;
        } else if (response.listaEmpresa?.length > 0) {
          this._listaEmpresaResponse.listaEmpresa.push(...response.listaEmpresa);
          this._ultimaPagina = false;
        }
        this._dataSource.data = this._listaEmpresaResponse.listaEmpresa;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  proximaPagina(): void {
    this._paginaAtual = this._paginaAtual + 1;
    this.pesquisar();
  }

  clickPesquisar(): void {
    this._paginaAtual = 0;
    this._listaEmpresaResponse = undefined;
    this.pesquisar();
  }

  public get idEmpresaGrupoControl(): FormControl {
    return this.model.get('idEmpresaGrupo') as FormControl;
  }
}
